import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { Quote, Vehicle } from '@sm360/widget-commons-vehicle';
import { ModalService, MODAL_NAMES } from '@sm360/widget-commons-general';
import VehicleTitle from 'commons-garage/components/GarageVehicle/VehicleTitle/VehicleTitle.jsx';
import VehicleImageWrapper from 'commons-garage/components/GarageVehicle/VehicleImageWrapper/VehicleImageWrapper.jsx';
import VehiclePayments from 'commons-garage/components/GarageVehicle/VehiclePayments/VehiclePayments.jsx';
import TileTag from 'commons-vehicle/Vehicle/components/TileTag/TileTag.jsx';
import 'commons-garage/components/GarageVehicle/GarageVehicle.scss';

class GarageVehicle extends React.Component {
    constructor(props) {
        super(props);

        this.initModal = this.initModal.bind(this);
        if (props.isReservationMode) {
            this.initModal(props);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isReservationMode) {
            if (!this.modal) {
                this.initModal(nextProps);
            } else if (nextProps.quote !== this.props.quote) {
                this.modal.updateProps({ quote: nextProps.quote });
            }
        }
    }

    initModal(props) {
        this.modal = ModalService.get(MODAL_NAMES.DEPOSIT_MODAL);
        this.modal.updateProps({
            depositAmount: 250,
            quote: props.quote,
        });
    }

    render() {
        const { vehicle, quote, deleteQuote } = this.props;
        const isNew = vehicle.getIsVehicleNew();
        const unavailableTileTag = (shouldRender, locale) => (
            <TileTag
                shouldRender={shouldRender}
                icon="icon-lock"
                background="#F5273F"
                color="#fff"
                text={LocaleService.t(locale)}
            />
        );

        const vehicleSoldTag = vehicle.isSold() && unavailableTileTag(vehicle.isSold(), 'GARAGE.VEHICLE_STATUS.SOLD');

        const vehicleReservedTag =
            vehicle.locked && unavailableTileTag(vehicle.onHold, 'GARAGE.VEHICLE_STATUS.RESERVED');

        const vehicleDiscontinuedTag =
            vehicle.discontinued && unavailableTileTag(vehicle.discontinued, 'GARAGE.VEHICLE_STATUS.DISCONTINUED');

        const stockNumber = vehicle.stockNumber && (
            <div id="stockNumber" className="is-light is-small">
                #{vehicle.stockNumber}
            </div>
        );

        return (
            <div className="vehicle-wrapper">
                <VehicleImageWrapper quote={quote} vehicle={vehicle} />
                <div className="vehicle-wrapper-info">
                    {vehicleSoldTag}
                    {vehicleReservedTag}
                    {vehicleDiscontinuedTag}
                    {stockNumber}
                    <VehicleTitle quote={quote} vehicle={isNew ? quote.vehicle : vehicle} deleteQuote={deleteQuote} />
                    <div className="vehicle-payment-info">
                        <VehiclePayments quote={quote} vehicle={vehicle} />
                    </div>
                </div>
            </div>
        );
    }
}

GarageVehicle.propTypes = {
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModelV25).isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    deleteQuote: PropTypes.func.isRequired,
    isReservationMode: PropTypes.bool.isRequired,
};

GarageVehicle.displayName = 'GarageVehicle';

export default GarageVehicle;
